export default "__VITE_ASSET__DP1Sl0xy__"